// 引入子路由
import Sub from '../frame/subroute.vue';
export default [
    // 首页
    {
        path: '/',
        name: 'index',
        component: resolve =>
            require(['@/views/identification/choose.vue'], resolve),
        meta: {
            title: '货主实名认证'
        }
    },
    // 货主实名认证选择入口
    {
        path: '/identitychoose',
        name: 'choose',
        component: resolve =>
            require(['@/views/identification/choose.vue'], resolve),
        meta: {
            title: '货主实名认证'
        }
    },
    // 信息认证
    {
        path: '/information',
        name: 'information',
        component: resolve =>
            require(['@/views/identification/information.vue'], resolve),
        meta: {
            title: '个人实名认证'
        }
    },
    // 提交成功
    {
        path: '/commitsuccess',
        name: 'commitsuccess',
        component: resolve =>
            require(['@/views/identification/CommitSuccess.vue'], resolve),
        meta: {
            title: '提交成功'
        }
    },
    // 零担订单
    {
        path: '/singlelist',
        name: 'singlelist',
        component: resolve => require(['@/views/order/single/list.vue'], resolve),
        meta: {
            title: '零担订单'
        }
    },
    {
        path: '/single/modify/check',
        name: '/modifyCheck',
        component: resolve =>
            require(['@/views/order/single/modifycheck.vue'], resolve),
        meta: {
            title: '改单审核'
        }
    },
    // 整车订单
    {
        path: '/wholevehicle',
        name: 'wholevehicle',
        component: resolve => require(['@/views/order/whole/list.vue'], resolve),
        meta: {
            title: '整车订单'
        }
    },
    // 整车订单详情
    {
        path: '/wholeinfo',
        name: 'wholeinfo',
        component: resolve => require(['@/views/order/whole/info.vue'], resolve),
        meta: {
            title: '整车订单详情'
        }
    },
    // 零担订单详情
    {
        path: '/singleinfo',
        name: 'singleinfo',
        component: resolve => require(['@/views/order/single/info.vue'], resolve),
        meta: {
            title: '零担订单详情'
        }
    },
    {
        path: '/evaluate',
        name: 'evaluate',
        component: resolve =>
            require(['@/views/order/evaluate/index.vue'], resolve),
        meta: {
            title: '评价'
        }
    },
    // 上传回单
    {
        path: '/orderreceipt',
        name: 'orderreceipt',
        component: resolve =>
            require(['@/views/order/whole/OrderReceipt.vue'], resolve),
        meta: {
            title: '上传回单'
        }
    },
    // 押金协议
    {
        path: '/depositagree',
        name: 'depositAgree',
        component: resolve =>
            require(['@/views/order/whole/depositAgree.vue'], resolve),
        meta: {
            title: '押金协议'
        }
    },
    // 申请付款
    {
        path: '/applypayment',
        name: 'applypayment',
        component: resolve =>
            require(['@/views/order/whole/ApplyPayment.vue'], resolve),
        meta: {
            title: '申请付款'
        }
    },
    // 申请付款
    {
        path: '/singleapplypayment',
        name: 'singleapplypayment',
        component: resolve =>
            require(['@/views/order/single/ApplyPayment.vue'], resolve),
        meta: {
            title: '申请付款'
        }
    },
    // 价目表 列表
    {
        path: '/priceList',
        name: 'priceList',
        component: resolve => require(['@/views/price/priceList.vue'], resolve),
        meta: {
            title: '最新报价'
        }
    },
    // 价目表 详情
    {
        path: '/priceDetail',
        name: 'priceDetail',
        component: resolve => require(['@/views/price/priceDetail.vue'], resolve),
        meta: {
            title: '最新报价'
        }
    },
    // 价目表 出发城市选择页面
    {
        path: '/priceChooseCity',
        name: 'priceChooseCity',
        component: resolve =>
            require(['@/views/price/priceChooseCity.vue'], resolve),
        meta: {
            title: '城市选择'
        }
    },
    // 价目表 价格查询
    {
        path: '/price/search',
        name: 'priceSearch',
        component: resolve => require(['@/views/price/priceSearch.vue'], resolve),
        meta: {
            title: '价格查询'
        }
    },
    // 人脸识别结果页
    {
        path: '/face',
        name: 'faceDiscern',
        component: resolve => require(['@/views/identification/face.vue'], resolve),
        meta: {
            title: '人脸识别'
        }
    },
    // 扫码 app进入货源详情
    {
        path: '/sourceScanCode',
        name: 'sourceScanCode',
        component: resolve =>
            require(['@/views/order/sourceScanCode/sourceScanCode.vue'], resolve),
        meta: {
            title: '扫码接单'
        }
    },
    // 货源码发货攻略
    {
        path: '/deliveryStrategy',
        name: 'deliveryStrategy',
        component: resolve =>
            require(['@/views/order/sourceCode/deliveryStrategy.vue'], resolve),
        meta: {
            title: '货源码发货攻略'
        }
    },
    // 获取零担物流轨迹信息
    {
        path: '/logisticsTrack',
        name: 'logisticsTrack',
        component: resolve =>
            require(['@/views/order/sms/logisticsTrack.vue'], resolve),
        meta: {
            title: '物流信息'
        }
    },
    {
        path: '/order/appeal',
        name: 'orderAppeal',
        component: resolve => require(['@/views/order/appeal/index.vue'], resolve),
        meta: {
            title: '申诉'
        }
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: resolve => require(['@/views/my/aboutUs.vue'], resolve),
        meta: {
            title: '关于我们'
        }
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: resolve => require(['@/views/agreement/index.vue'], resolve),
        meta: {
            title: '投诉协议'
        }
    },
    // 我的模块
    {
        path: '/my',
        name: 'my',
        component: Sub,
        meta: {
            title: '我的'
        },
        children: [
            {
                path: 'truck',
                name: 'truck',
                component: resolve => require(['@/views/my/truck/index.vue'], resolve),
                meta: {
                    title: '熟车管理'
                }
            },
            {
                path: 'truck/add',
                name: 'truckAdd',
                component: resolve => require(['@/views/my/truck/add.vue'], resolve),
                meta: {
                    title: '添加熟车'
                }
            },
            {
                path: 'truck/detail',
                name: 'truckDetail',
                component: resolve => require(['@/views/my/truck/detail.vue'], resolve),
                meta: {
                    title: '熟车详情'
                }
            },
            {
                path: 'balance',
                name: 'balance',
                component: resolve => require(['@/views/my/balance.vue'], resolve),
                meta: {
                    title: '余额'
                }
            },
            {
                path: 'recharge',
                name: 'recharge',
                component: resolve => require(['@/views/my/recharge.vue'], resolve),
                meta: {
                    title: '充值'
                }
            },
            {
                path: 'particulars',
                name: 'particulars',
                component: resolve => require(['@/views/my/particulars.vue'], resolve),
                meta: {
                    title: '明细'
                }
            },
            {
                path: 'bill',
                name: 'bill',
                component: resolve => require(['@/views/my/bill.vue'], resolve),
                meta: {
                    title: '整车账单'
                }
            },
            {
                path: 'singlebill',
                name: 'singlebill',
                component: resolve => require(['@/views/my/singleBill.vue'], resolve),
                meta: {
                    title: '零担账单'
                }
            },
            {
                path: 'pay',
                name: 'pay',
                component: resolve => require(['@/views/my/pay.vue'], resolve),
                meta: {
                    title: '支付'
                }
            },
            {
                path: 'pay/success',
                name: 'paysuccess',
                component: resolve => require(['@/views/my/paysuccess.vue'], resolve),
                meta: {
                    title: '支付成功'
                }
            }
        ]
    },
    {
        path: '/activity',
        component: Sub,
        meta: {
            title: '活动'
        },
        children: [
            {
                path: 'index',
                name: 'activityIndex',
                component: resolve => require(['@/views/activity/index.vue'], resolve),
                meta: {
                    title: '活动中心'
                }
            },
            {
                path: 'boxRental',
                name: 'boxRental',
                component: resolve => require(['@/views/activity/boxRental.vue'], resolve),
                meta: {
                    title: '挂厢租赁'
                }
            },
            {
                path: 'wxPop',
                name: 'wxPop',
                component: resolve => require(['@/views/activity/wxPop.vue'], resolve),
                meta: {
                    title: '添加专属客服'
                }
            },
            {
                path: 'redp',
                name: 'activityRedp',
                component: resolve =>
                    require(['@/views/activity/redp/index.vue'], resolve),
                meta: {
                    title: '升级账户拆红包'
                }
            },
            {
                path: 'center',
                name: 'activitycenter',
                component: resolve =>
                    require(['@/views/activity/v2/index.vue'], resolve),
                meta: {
                    title: '蜂狂赚钱'
                }
            },
            {
                path: 'visitmanage',
                name: 'visitmanage',
                component: resolve => require(['@/views/activity/manage.vue'], resolve),
                meta: {
                    title: '邀请管理'
                }
            },
            {
                path: 'withdrawalrecord',
                name: 'withdrawalrecord',
                component: resolve =>
                    require(['@/views/activity/WithdrawalRecord.vue'], resolve),
                meta: {
                    title: '提现记录'
                }
            },
            {
                path: 'authentication',
                name: 'authentication',
                component: resolve =>
                    require(['@/views/activity/authentication.vue'], resolve),
                meta: {
                    title: '快速认证'
                }
            },
            {
                path: 'profit',
                name: 'profit',
                component: resolve => require(['@/views/activity/profit.vue'], resolve),
                meta: {
                    title: '我的收益'
                }
            },
            {
                path: 'rule',
                name: 'rule',
                component: resolve => require(['@/views/activity/rule.vue'], resolve),
                meta: {
                    title: '佣金规则'
                }
            },
            {
                path: 'cash',
                name: 'cash',
                component: resolve => require(['@/views/activity/cash.vue'], resolve),
                meta: {
                    title: '收益提现'
                }
            },
            {
                path: 'driver-cash', // 司机app提现页面
                name: 'driver-cash',
                component: resolve =>
                    require(['@/views/activity/driver-cash.vue'], resolve),
                meta: {
                    title: '收益提现'
                }
            },
            {
                path: 'cash/success',
                name: 'cashSuccess',
                component: resolve =>
                    require(['@/views/activity/cashSuccess.vue'], resolve),
                meta: {
                    title: '收益提现'
                }
            },
            {
                path: 'qrcode',
                name: 'qrcode',
                component: resolve => require(['@/views/activity/qrcode.vue'], resolve),
                meta: {
                    title: '二维码邀请'
                }
            },
            {
                path: 'onlineToubao',
                name: 'onlineToubao',
                component: resolve =>
                    require(['@/views/activity/onlineToubao.vue'], resolve),
                meta: {
                    title: '在线投保'
                }
            },
            {
                path: 'insureWY',
                name: 'insureWY',
                component: resolve =>
                    require(['@/views/activity/insureWY.vue'], resolve),
                meta: {
                    title: '在线投保'
                }
            },
            {
                path: 'fiancePage',
                name: 'fiancePage',
                component: resolve =>
                    require(['@/views/activity/fiancePage.vue'], resolve),
                meta: {
                    title: '金融服务'
                }
            },
            {
                path: 'toubaoInfo',
                name: 'toubaoInfo',
                component: resolve =>
                    require(['@/views/activity/toubaoInfo.vue'], resolve),
                meta: {
                    title: '投保须知'
                }
            },
            {
                path: 'oil',
                name: 'oil',
                component: resolve => require(['@/views/activity/oil.vue'], resolve),
                meta: {
                    title: '加油'
                }
            },
            {
                path: 'specialCar',
                name: 'specialCar',
                component: resolve =>
                    require(['@/views/activity/specialCar.vue'], resolve),
                meta: {
                    title: '专车'
                }
            },
            {
                path: 'sendMethods',
                name: 'sendMethods',
                component: resolve =>
                    require(['@/views/activity/sendMethods.vue'], resolve),
                meta: {
                    title: '发货攻略'
                }
            },
            {
                path: 'jd/message',
                name: 'jdSendMessage',
                component: resolve =>
                    require(['@/views/activity/jd/message.vue'], resolve),
                meta: {
                    title: '京东金融'
                }
            },
            {
                path: 'dailyPoster',
                name: 'dailyPoster',
                component: resolve =>
                    require(['@/views/activity/daily-poster.vue'], resolve),
                meta: {
                    title: '每日营销'
                }
            },
            {
                path: 'timedPoster',
                name: 'timedPoster',
                component: resolve =>
                    require(['@/views/activity/timed-poster.vue'], resolve),
                meta: {
                    title: '限时特价'
                }
            },
            {
                path: 'education',
                component: Sub,
                children: [
                    {
                        path: '20221014',
                        name: 'edu20221014',
                        component: resolve => require(['@/views/activity/education/20221014.vue'], resolve)
                    },
                    {
                        path: '20221101_1',
                        name: 'edu20221101_1',
                        component: resolve => require(['@/views/activity/education/20221101_1.vue'], resolve)
                    },
                    {
                        path: '20221101_2',
                        name: 'edu20221101_2',
                        component: resolve => require(['@/views/activity/education/20221101_2.vue'], resolve)
                    },
                    {
                        path: '20221101_3',
                        name: 'edu20221101_3',
                        component: resolve => require(['@/views/activity/education/20221101_3.vue'], resolve)
                    }
                ]
            },
            {
                path: '20221014_1',
                name: '20221014_1',
                component: resolve =>
                    require(['@/views/activity/20221014/1.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_2',
                name: '20221014_2',
                component: resolve =>
                    require(['@/views/activity/20221014/2.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_3',
                name: '20221014_3',
                component: resolve =>
                    require(['@/views/activity/20221014/3.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_4',
                name: '20221014_4',
                component: resolve =>
                    require(['@/views/activity/20221014/4.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_5',
                name: '20221014_5',
                component: resolve =>
                    require(['@/views/activity/20221014/5.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_6',
                name: '20221014_6',
                component: resolve =>
                    require(['@/views/activity/20221014/6.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_7',
                name: '20221014_7',
                component: resolve =>
                    require(['@/views/activity/20221014/7.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '20221014_8',
                name: '20221014_8',
                component: resolve =>
                    require(['@/views/activity/20221014/8.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: '/',
                name: 'template',
                component: resolve => require(['@/views/activity/education/template.vue'], resolve)
            }
        ]
    },
    // 项目主页
    {
        path: '/prohomepage',
        name: '项目主页',
        component: resolve => require(['@/views/project/prohomepage.vue'], resolve),
        meta: {
            title: '项目主页'
        }
    },
    // 跳转app
    {
        path: '/app',
        component: Sub,
        children: [
            {
                path: 'redirect',
                name: 'appRedirect',
                component: resolve => require(['@/views/app/redirect.vue'], resolve)
            }
        ]
    },
    // 授权协议
    {
        path: '/licensepage',
        name: '授权协议',
        component: resolve => require(['@/views/project/licensepage.vue'], resolve),
        meta: {
            title: '授权协议'
        }
    },
    // 锡望贷
    {
        path: '/finance',
        component: Sub,
        children: [
            {
                path: 'xs',
                name: 'financeXs',
                component: resolve => require(['@/views/finance/xs/index.vue'], resolve),
                meta: {
                    title: '锡望贷'
                }
            }
        ]
    },
    // 分享
    {
        path: '/share',
        component: Sub,
        children: [
            {
                path: 'line',
                name: 'shareLine',
                component: resolve => require(['@/views/share/line.vue'], resolve),
                meta: {
                    title: '推荐货主'
                }
            },
            {
                path: 'driver',
                name: 'shareDriver',
                component: resolve => require(['@/views/share/driver.vue'], resolve),
                meta: {
                    title: '司机名片'
                }
            }
        ]
    },
    // 发货帮
    {
        path: '/fhb',
        component: Sub,
        children: [
            {
                path: 'face',
                name: 'fhbFace',
                component: resolve => require(['@/views/fhb/face/index.vue'], resolve),
                meta: {
                    title: ''
                }
            },
            {
                path: 'bankLink',
                name: 'fhbBankLink',
                component: resolve => require(['@/views/fhb/bankLink/index.vue'], resolve),
                meta: {
                    title: ''
                }
            }
        ]
    },
    // 经纪人推荐函
    {
        path: '/sign',
        component: Sub,
        children: [
            {
                path: 'recommendation',
                name: 'recommendation',
                component: resolve => require(['@/views/signContract/recommendation.vue'], resolve),
                meta: {
                    title: ''
                }
            }
        ]
    },
    // 经纪人协议
    {
        path: '/sign',
        component: Sub,
        children: [
            {
                path: 'agrement',
                name: 'agrement',
                component: resolve => require(['@/views/signContract/agrement.vue'], resolve),
                meta: {
                    title: ''
                }
            }
        ]
    },
    // 经纪人协议
    {
        path: '/track',
        component: Sub,
        children: [
            {
                path: 'pwd',
                name: 'trackPwd',
                component: resolve => require(['@/views/track/pwd.vue'], resolve),
                meta: {
                    title: '密码'
                }
            },
            {
                path: 'order',
                name: 'trackOrder',
                component: resolve => require(['@/views/track/order.vue'], resolve),
                meta: {
                    title: '客户名称订单'
                }
            },
            {
                path: 'map',
                name: 'trackMap',
                component: resolve => require(['@/views/track/map.vue'], resolve),
                meta: {
                    title: '订单轨迹'
                }
            }
        ]
    },
    // 代开委托函签署落地页
    {
        path: '/sign',
        component: Sub,
        children: [
            {
                path: 'authorization',
                name: 'authorization',
                component: resolve => require(['@/views/signContract/signAuthorization.vue'], resolve),
                meta: {
                    title: '签署完成'
                }
            }
        ]
    },
    // 文档中心查看
    {
        path: '/doc/:fileName',
        name: 'doc',
        component: resolve =>
            require(['@/views/doc/index.vue'], resolve),
        meta: {
            title: ''
        }
    },
    // 红包活动
    {
        path: '/redPacket',
        name: 'redPacket',
        component: resolve =>
            require(['@/views/redPacket/index.vue'], resolve),
        meta: {
            title: '红包活动'
        }
    },
    // 投保
    {
        path: '/insure',
        name: 'insure',
        component: resolve =>
            require(['@/views/insure/index.vue'], resolve),
        meta: {
            title: '货损保障'
        }
    },
    // 投保
    {
        path: '/insure/accident',
        name: 'insureAccident',
        component: resolve =>
            require(['@/views/insure/accident.vue'], resolve),
        meta: {
            title: '货损保障'
        }
    },
    // 投保
    {
        path: '/insure/feedback',
        name: 'insureFeedback',
        component: resolve =>
            require(['@/views/insure/feedback.vue'], resolve),
        meta: {
            title: '投保成功'
        }
    },
    // 查看
    {
        path: '/insure/show/:type',
        name: 'insureShow',
        component: resolve =>
            require(['@/views/insure/show.vue'], resolve),
        meta: {
            title: ''
        }
    },
    // 货主处理签订网货合同任务
    {
        path: '/contract',
        component: Sub,
        children: [
            {
                path: 'roadContract',
                name: 'roadContract',
                component: resolve => require(['@/views/contract/road/index.vue'], resolve),
                meta: {
                    title: '签订网络合同'
                }
            },
            {
                path: 'step1',
                name: 'step1',
                component: resolve => require(['@/views/contract/step/1.vue'], resolve),
                meta: {
                    title: '签署合同'
                }
            },
            {
                path: 'step2',
                name: 'step2',
                component: resolve => require(['@/views/contract/step/2.vue'], resolve),
                meta: {
                    title: '签署合同'
                }
            },
            {
                path: 'stepResult',
                name: 'stepResult',
                component: resolve => require(['@/views/contract/step/result.vue'], resolve),
                meta: {
                    title: '签署合同'
                }
            }
        ]
    },
    // 无人车
    {
        path: '/autoCar/intro',
        name: 'autoCarIntro',
        component: resolve =>
            require(['@/views/autoCar/intro.vue'], resolve),
        meta: {
            title: ''
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/router.js